import { DrawerObject } from '../../../../components/drawer/drawer.types';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { RefParamRepository } from '../../../../store/ref-param-state/ref-param-state.repository';

interface getRefParamsUpdateDrawerObjectProps {
  store?: RefParamRepository;
  formObject?: DynamicForm;
  action?: () => void;
  toggleVisibility?: () => void;
}

export const getRefParamsUpdateDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: getRefParamsUpdateDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.refParams.editTitle',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.refParams.form.submit',
        onClick: () => action?.(),
      },
      {
        label: 'settings.refParams.form.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
